// Vendors
import 'src/scripts/vendor/jquery'
import 'src/scripts/vendor/bootstrap'
import 'src/scripts/vendor/lazysizes.min'
import 'src/scripts/vendor/lightgallery.min'
import 'src/scripts/vendor/glide.min'
import 'src/scripts/modules/nav'
import 'src/scripts/modules/table'
import 'src/scripts/modules/gallery'
import 'src/scripts/modules/filter-blog'
import 'src/scripts/modules/popup'
import 'src/scripts/modules/search'
// Garde-fou commun des formulaires de recherche. À GARDER importé même si
// l'assistant RAG est mis en pause : il porte la touche Entrée des textareas.
import 'src/scripts/modules/search-forms'
// ASSISTANT RAG : la mise en pause se fait côté CMS (global fields, case
// « Désactiver l'assistant citoyen »), pas ici. Ce module ne s'accroche qu'aux
// formulaires [data-rag-search], qui ne sont plus rendus quand la case est cochée.
import 'src/scripts/modules/rag-assistant'
// Placeholder animé de la carte assistant. Séparé de rag-assistant.js :
// il reste utile si l'assistant est mis en pause et que la carte retombe
// sur la recherche.
import 'src/scripts/modules/rag-placeholder'
// Pagination par 6 des groupes de collection de la page de résultats.
import 'src/scripts/modules/collection-pager'
import 'src/scripts/modules/slider'
// import 'src/scripts/modules/booking-app' // Replaced by GemengApp Hall Booking module
import 'src/scripts/modules/accordion'
import 'src/scripts/modules/weather'
import 'src/scripts/modules/navlateral'
import 'src/scripts/modules/map'
import 'src/scripts/modules/menuLeft'